import { useMemo } from "react";
import { Col, Row } from "reactstrap";
import Widget from "src/modules/data-protection/pages/admin/dashboard/components/Widget";
import applicableIcon from "src/modules/data-protection/assets/icons/controls_applicable.svg";
import avgMaturityIcon from "src/modules/data-protection/assets/icons/controls_avg_maturity.svg";
import notApplicableIcon from "src/modules/data-protection/assets/icons/controls_not_applicable.svg";
import readinessScoreIcon from "src/modules/data-protection/assets/icons/controls_readiness_score.svg";
import totalControlsIcon from "src/modules/data-protection/assets/icons/controls_total_controls.svg";

import { getDashboardMetric, isTisaxFramework } from "src/modules/data-protection/helpers/Controls";

const toWidgetConfig = ({ title, metric, icon }) => {
  const { amount, percent } = getDashboardMetric(metric);

  return {
    title,
    amount,
    icon,
    chart: { show: true, percent },
  };
};

const ControlsOverviewWidgets = ({ dashboardData, selectedFramework }) => {
  const controlsOverviewWidgets = useMemo(() => {
    const kpis = dashboardData?.kpis || {};
    const widgets = [
      toWidgetConfig({
        title: "Total Controls",
        metric: kpis.total_controls,
        icon: totalControlsIcon,
      }),
      toWidgetConfig({
        title: "Applicable",
        metric: kpis.applicable_controls,
        icon: applicableIcon,
      }),
      toWidgetConfig({
        title: "Not Applicable",
        metric: kpis.not_applicable_controls,
        icon: notApplicableIcon,
      }),
    ];

    if (isTisaxFramework(selectedFramework)) {
      const maturity = getDashboardMetric(kpis.avg_maturity_level);
      widgets.push({
        title: "Avg Maturity Level",
        amount: Number(maturity.amount).toFixed(1),
        icon: avgMaturityIcon,
        chart: { show: true, percent: maturity.percent },
      });
    }

    const readiness = getDashboardMetric(kpis.readiness_score);
    widgets.push({
      title: "Readiness Score",
      amount: readiness.amount,
      icon: readinessScoreIcon,
      chart: { show: true, percent: readiness.percent },
    });

    return widgets;
  }, [dashboardData, selectedFramework]);

  const columnClass =
    controlsOverviewWidgets.length === 5
      ? "row-cols-lg-5"
      : "row-cols-lg-4";

  return (
    <Row className={`mb-4 row-cols-1 row-cols-md-2 ${columnClass}`}>
      {controlsOverviewWidgets.map((widget) => (
        <Col key={widget.title} className="mb-3">
          <Widget {...widget} />
        </Col>
      ))}
    </Row>
  );
};

export default ControlsOverviewWidgets;
